import { Button } from "@/components/ui/button";
import { Icons } from "@/components/ui/icons";
import { OnboardingCard } from "./onboarding-card";
import { useT } from "@/i18n";
import { firstRunMessages } from "@/i18n/messages/first-run";

interface Props {
  onGetStarted: () => void;
}

export function OnboardingDoneStep({ onGetStarted }: Props) {
  const t = useT(firstRunMessages);
  return (
    <OnboardingCard data-testid="onboarding-done">
      <div className="flex flex-col items-center gap-3 py-4">
        <div className="flex h-14 w-14 items-center justify-center rounded-full border">
          <Icons.CheckCircle className="h-7 w-7 text-accent" />
        </div>
        <h1 className="text-lg font-semibold text-[var(--agent-aurora-text)]">
          {t("allSet")}
        </h1>
        <p className="text-center text-sm text-[var(--agent-aurora-text-muted)]">
          {t("readyToGo")}
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <Button
          data-testid="onboarding-get-started"
          size="lg"
          onClick={onGetStarted}
        >
          {t("getStarted")}
        </Button>
      </div>
    </OnboardingCard>
  );
}
